import React, { useEffect, useState } from "react";
import { useRecoilValue } from "recoil";
import ArrowIcon from "@/assets/icons/arrow-icon-grey.svg";
import Div100vh from "react-div-100vh";
import CustomDrawer from "@/components/common/drawer";
import WhatsappIcon from "@/assets/icons/whatsapp-icon-green.svg";
import BannerImg from "@/assets/images/BannerImg.png";
import { userDataAtom } from "@/recoil/atom/userDataAtom";
import { landlordDataAtom } from "@/recoil/atom/landlordDataAtom";
import { useRecoilState } from "recoil";
import {
  fetchData,
  dropWaMessage,
  whatsappLandlordURL,
  supportURL,
} from "@/lib/helper";
import { useNavigate } from "react-router-dom";
import { ArrowLeft, Download, House } from "lucide-react";
import ClubBenefits from "./ClubBenefits";

export default function ClubInviteScreen() {
  const navigate = useNavigate();
  const userData = useRecoilValue(userDataAtom);
  const [landlordData, setLandlordData] = useRecoilState(landlordDataAtom);
  const [benefitsDrawer, setBenefitsDrawer] = useState(false);

  const getLandlord = async () => {
    const data = await fetchData("user/my-landlords");
    setLandlordData(data);
  };

  useEffect(() => {
    getLandlord();
  }, []);

  return (
    <Div100vh className="flex flex-col p-10 bg-[#010101]">
      {/* <button onClick={() => (window.location.href = "/")}>
        <House size={36} />
      </button> */}
      <div className="flex flex-col justify-between items-center h-full">
        <div className="p-4">
          <img
            src={BannerImg}
            className="object-scale-down max-w-36"
            alt="banner-image"
          />
        </div>
        <div className="flex flex-col gap-10 items-center">
          <div className="flex flex-col items-center">
            <span className="heading">
              Share the club brochure & invite your landlord
            </span>
            <span className="text-[#9d9d9d] text-sm">
              We shall speak to you before reaching out to your Landlord.
            </span>
          </div>
          <div className="flex flex-col items-center gap-2">
            {landlordData.length > 0 ? (
              <a
                onClick={() =>
                  dropWaMessage(
                    "Share CLUB invite",
                    "Invite Screen - Tenant flow"
                  )
                }
                href={
                  whatsappLandlordURL(
                    landlordData[0]?.phone,
                    userData.referralCode
                  ) || supportURL
                }
                target="_blank"
                className="w-full px-8 py-3 text-[#48c42c] text-xs flex border rounded-full justify-center gap-2 items-center border-[#48c42c]"
              >
                <span>Share CLUB invite</span>
                <img src={WhatsappIcon} alt="" className="w-6" />
              </a>
            ) : (
              <a className="w-full px-8 py-3 text-[#48c42c]/0 text-xs flex rounded-full justify-center gap-2 items-center bg-gradient-to-br from-[#1b1b1b] via-[#222] to-[#444]/80 animate-pulse">
                <span>Share CLUB invite</span>
                <img src={WhatsappIcon} alt="" className="w-6 hidden" />
              </a>
            )}
            <a
              // onClick={() =>
              //   dropWaMessage(
              //     "Share CLUB invite",
              //     "Invite Screen - Tenant flow"
              //   )
              // }
              href={"download/pdfs/Landlord Brochure_CirclePe.pdf"}
              rel="noopener noreferrer"
              download={"Landlord Brochure_CirclePe.pdf"}
              target="_blank"
              className="w-full p-4 text-[#cccccc] my-2 flex gap-2 border rounded-full text-xs tracking-wide justify-between items-center border-[#999]"
            >
              <span className="min-w-max">Download Landlord Brochure</span>

              <Download size={18} />
            </a>
            {/* <a
                // onClick={() =>
                //   dropWaMessage(
                //     "Share CLUB invite",
                //     "Invite Screen - Tenant flow"
                //   )
                // }
                href={
                  "download/pdfs/Landlord Brochure_CirclePe.pdf"
                }
                rel="noopener noreferrer"
                download={"Landlord Brochure_CirclePe.pdf"}
                target="_blank"
                className="w-full p-4 text-[#cccccc] font-semibold my-2 flex gap-2 border justify-between items-center border-[#ccc]"
              >
              /*  <img src={WhatsappIcon} alt="" className="max-w-6" /> 
                <span className="min-w-max">Download Landlord Brochure</span>
                <img src={ArrowIcon} alt="" className="" />
                <Download size={18}/>
              </a> */}
            <button
              className="text-xs text-[#acacad] flex items-center justify-center gap-2 hover:text-[#ddd]"
              onClick={() => (window.location.href = "/")}
            >
              <span className="text-x">←</span>{" "}
              <span className="hover:underline ">Back to Home Screen</span>
            </button>
          </div>
          <CustomDrawer
            isOpen={benefitsDrawer}
            onClose={() => setBenefitsDrawer((prevState) => !prevState)}
            removePadding
          >
            <ClubBenefits setBenefitsDrawer={setBenefitsDrawer} />
          </CustomDrawer>

          {/* <button className="flex justify-center w-full gap-2 items-center">
            <img src={CallIcon} alt="" />
            <span className="text-[#a4a4a4]">Reach out to us</span>
          </button> */}
        </div>
      </div>
    </Div100vh>
  );
}
